@if (!item.deleted) {
  <mat-list-item (click)="openItemDialog(item)">
    <div [class.empty]="item.quantity==0||item.unequipped" matTooltip="{{item.description}}">
      {{item.inventoryString()}}
    </div>
    <div class="mat-list-actions">
      <button mat-icon-button (click)="consume(item, $event)" aria-label="Remove one">
        <mat-icon>remove</mat-icon>
      </button>
      <button mat-icon-button (click)="collect(item, $event)" aria-label="Add one">
        <mat-icon>add</mat-icon>
      </button>
      <mat-icon [color]="item.unequipped ? 'primary' : 'warn'" class="equip-icon" [class.unequipped]="item.unequipped" (click)="toggleEquip($event)">pan_tool</mat-icon>
    </div>
    <mat-divider></mat-divider>
  </mat-list-item>
}
